export default {
      id: "schedule-clock-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#schedule-clock",
      toString: function () {
        return this.url;
      }
    }